export default __webpack_public_path__ + "static/media/1.9a626bb8.png";